import { render, staticRenderFns } from "./FormConfigurations.vue?vue&type=template&id=b012c89e&"
import script from "./FormConfigurations.vue?vue&type=script&lang=js&"
export * from "./FormConfigurations.vue?vue&type=script&lang=js&"
import style0 from "./FormConfigurations.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports